module.exports = __webpack_public_path__ + "3123cda54d057edac7d34fe60b73d94b.woff2";